import {
  CreateChallengeCategoryOperationRequest,
  CreateChallengeCategoryRequest,
  CreateChallengeCategoryResponse,
} from "@revolutionrobotics/admin-api";
import React, { useState, useContext } from "react";
import { Col, Form, Row } from "react-bootstrap";
import { ChallengeApi } from "../../services/configuration";
import { SetError } from "../../services/general";
import { ButtonWithStyle } from "../ButtonWithStyle";
import { FormItem } from "../FormItem";
import { LanguageSelector } from "../Language/LanguageSelector";
import LanguageContext from "../../services/LanguageContext";

interface SkillCategoryFormProps {
  insertAfterId?: string;
  setError: Function;
  refresh: Function;
}

export function NewChallengeCategoryForm({
  insertAfterId,
  setError,
  refresh,
}: SkillCategoryFormProps) {
  const [validated, setValidated] = useState(false);
  const [inputs, setInputs] = useState<any | null>(null);
  const { language } = useContext(LanguageContext);

  const handleSubmit = (event: any) => {
    event.preventDefault();
    event.stopPropagation();
    setValidated(true);

    if (!inputs || !inputs.title) return;

    const details: CreateChallengeCategoryRequest = {
      lang: language,
      title: inputs.title,
    };

    const req: CreateChallengeCategoryOperationRequest = {
      request: details,
      insertAfterID: insertAfterId || undefined,
    };

    ChallengeApi.createChallengeCategory(req)
      .then(
        (response: CreateChallengeCategoryResponse) => {
          console.log(response.id, "has been created.");
        },
        (error) => {
          SetError(error, setError);
        }
      )
      .finally(() => {
        refresh();
      });
  };

  const handleChange = (event: any) => {
    const name = event.target.name;
    const value = event.target.value;
    setInputs((values: any) => ({ ...values, [name]: value }));
  };

  return (
    <Form noValidate validated={validated} onSubmit={handleSubmit}>
      <Row className="mb-3">
        <Col>
          <Row className="mb-3">
            <Form.Label>Language</Form.Label>
            <LanguageSelector />
          </Row>
          <Row>
            <FormItem
              title={"Title"}
              type={"text"}
              required={true}
              name={"title"}
              handleChange={handleChange}
            />
          </Row>
        </Col>
      </Row>

      <ButtonWithStyle buttonTitle="Create" type="submit" variant="primary" />
    </Form>
  );
}
